module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '  ';
  if (gon.display_options.rich_action_active) { ;
__p += '\n  \n  <a id="action_link_anchor" href="' +
((__t = ( getLink() )) == null ? '' : __t) +
'" class="rich_action_link_holder" target="_blank">\n    <div class="product_image_thumb" style="background-image:url(' +
((__t = ( getImage() )) == null ? '' : __t) +
');"></div>\n    <div class="product_info_holder">\n      <div class="product_title_link_holder">\n        <div class="product_title">' +
((__t = ( getProductTitle() )) == null ? '' : __t) +
'</div>\n        <div class="clearfix"></div>\n      </div>\n    </div>\n  </a>\n  ';
 } ;
__p += '\n  <div id="buynow_button_holder">\n        \n    <a id="action_link_anchor" href="' +
((__t = ( decode_utf8(getActionLink()) )) == null ? '' : __t) +
'" target="_blank">' +
((__t = ( decode_utf8(getActionText()) )) == null ? '' : __t) +
'</a>\n    \n  </div>';

}
return __p
}